import { GraphQLClient } from "../../../../shared/gql-client";
import {
  RequestModel,
  RequestResponseModel,
} from "../../domain/models/requestModel";
import * as gqlBuilder from "gql-query-builder";
import { gql } from "@apollo/client";

export default class RequestService {
  private client: GraphQLClient | undefined;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  delete(id: number): Promise<RequestResponseModel> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.mutation({
        operation: "deleteRequest",
        variables: {
          id: {
            name: "id",
            type: "ID!",
            value: id,
          },
        },
        fields: ["id", "type", "source_type", "source_id"],
      });

      this.client
        ?.mutate("deleteRequest", gql(query), variables)
        .then((response) => {
          const data = response as RequestResponseModel;

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  mutate(request: RequestModel): Promise<RequestResponseModel> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.mutation({
        operation: "upsertRequest",
        variables: {
          input: {
            value: {
              id: request.id !== undefined ? request.id : null,
            },
            required: true,
          },
        },
        fields: ["id", "status", "invoice_status"],
      });

      this.client
        ?.mutate("upsertRequest", gql(query), variables)
        .then((response) => {
          const data = response as RequestResponseModel;
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  updateState(
    id: number,
    state: string,
    comment?: string,
  ): Promise<RequestResponseModel> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.mutation({
        operation: "updateRequestState",
        variables: {
          id: {
            name: "id",
            type: "ID!",
            value: id,
          },
          state: {
            name: "state",
            type: "String!",
            value: state,
          },
          comment: {
            name: "comment",
            type: "String",
            value: comment,
          },
        },
        fields: ["id"],
      });

      this.client
        ?.mutate("updateRequestState", gql(query), variables)
        .then((response) => {
          const data = response as RequestResponseModel;
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
